module.exports = __webpack_public_path__ + "static/img/placeholder360.818f8887.png";